;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "cards",
  props: ["status_api_url", "invoice_no", "callback_url"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      total_amount: 0
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.logo = this.$attrs["logo"];
    this.set_total_amount();
    $("#pesalinkModal").on("hidden.bs.modal", function () {
      _this.destroyTimer();
    });
  },
  methods: {
    destroyTimer: function destroyTimer() {
      this.$refs.timer.destroyTimer();
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"pesalinkModal","tabindex":"-1","role":"dialog","aria-labelledby":"pesalinkModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"alert alert-warning mt-4"},[_vm._v("Service currently available for Credit Bank, DTB, KWFT and BOA. Other banks to join soon.")]),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay using Pesalink")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.currency)+"."+_vm._s(_vm.total_amount))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('ol',[_c('li',[_vm._v("Log in to your Bank App or USSD")]),_vm._v(" "),_c('li',[_vm._v("Select Pesalink")]),_vm._v(" "),_c('li',[_vm._v("Go to “Send to Phone” option")]),_vm._v(" "),_c('li',[_vm._v("Type 206206 as the phone number.")]),_vm._v(" "),_c('li',[_vm._v("Select Bank")]),_vm._v(" "),_c('li',[_vm._v("Enter the Amount. "+_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount))]),_vm._v(" "),_c('li',[_vm._v("Reason for payment enter : "+_vm._s(_vm.invoice_no))]),_vm._v(" "),_c('li',[_vm._v("Complete the transaction")]),_vm._v(" "),_c('li',[_vm._v("\n                      You will receive an SMS confirmation from Pesalink (if your number is linked) and also from\n                      your bank.\n                    ")])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("After you receive a successful reply, click the complete button below.")])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"pesalink","status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_no,"callback_url":_vm.callback_url}})],1)])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4e97f592", __vue__options__)
  } else {
    hotAPI.reload("data-v-4e97f592", __vue__options__)
  }
})()}